import {Component, Host, Prop, State, h} from "@stencil/core";
import {notificationsStore} from "../stores/notificationsStore";

/** Notification bell component to display number of notifications */
@Component({
	tag: "uxn-notification-bell",
	styleUrl: "notification-bell.scss",
	shadow: false,
})
export class NotificationBell {
	/** Override default connection timeout */
	@Prop() connectionTimeout: number = 30000;
	@State() connectError: boolean = false;

	#timeoutId: ReturnType<typeof setTimeout> | null = null;

	componentDidLoad() {
		this.#timeoutId = setTimeout(() => {
			if (notificationsStore.hasFailedInitializing !== null) return; // dangling store only returns null props
			this.connectError = true;
			console.error("Failed to connect to notificationsStore");
		}, this.connectionTimeout);
	}

	disconnectedCallback() {
		if (this.#timeoutId) clearTimeout(this.#timeoutId);
	}

	//TODO temp solution until https://gitlab.com/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/-/issues/42
	#getIndicator() {
		if (!this.connectError && notificationsStore.hasFailedInitializing === null) return "🔵"; // initial state: before timeout; store might be dangling (only returning null props)

		if (notificationsStore.isLoading) return "🔵"; // loading always takes priority over errors to signal that a recovery attempt is in progress
		if (this.connectError || notificationsStore.hasFailedInitializing || notificationsStore.hasFailedGet) return "🔴";
		return null;
	}

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return (
			<Host class="uxn-notification-bell">
				<ux-notification-bell counter={notificationsStore.count ?? 0} />
				<span class="indicator">{this.#getIndicator()}</span>
			</Host>
		);
	}
}
